module.exports = __webpack_public_path__ + "img/case-top-bg-1.c7a63aea.png";